module.exports = __webpack_public_path__ + "static/media/size_guide_banner_r.98c264e9.jpg";